import * as React from "react";
import BaseComponent from "~/components/BaseComponent/index";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
import { ProducerSuppliedFormSection } from "~/components/form/Sections/index";
import { Summary } from "~/components/form/index";
import { BoundStringCheckbox } from "~/primitiveComponents/form/Checkbox/StringCheckbox";
import { ValueInPropertiesOrErrorsHasChanged } from "~/utils/ShouldUpdate/ValueInPropertiesHasChanged";
import type { ActionEditProps } from "../../pluginRegistry";
const StringProperties = {
    "Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings": "",
};
type ConfigurationVariablesProperties = {
    [P in keyof typeof StringProperties]: string;
};
export class ConfigurationVariablesReadOnly extends BaseComponent<ActionEditProps<ConfigurationVariablesProperties>, never> {
    shouldComponentUpdate(nextProps: ActionEditProps<ConfigurationVariablesProperties>) {
        return ValueInPropertiesOrErrorsHasChanged(StringProperties, nextProps, this.props);
    }
    summary() {
        if ((this.props.properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"] || "").toLowerCase() !== "false") {
            return Summary.summary(<span>
                    Entries in <em>.config</em> files will be updated with variable values
                </span>);
        }
        return Summary.placeholder(<span>
                Entries in <em>.config</em> files will not be updated with variable values
            </span>);
    }
    render() {
        const properties = this.props.properties;
        return (<ProducerSuppliedFormSection errorKey="Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings" isExpandedByDefault={this.props.expandedByDefault} title=".NET Configuration Variables" summary={this.summary()} help="If set, replace appSettings and connectionString entries in any .config files.">
                <BoundStringCheckbox variableLookup={{
                localNames: this.props.localNames,
            }} resetValue={"False"} value={properties["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"]} onChange={(x) => this.props.setProperties({ ["Octopus.Action.Package.AutomaticallyUpdateAppSettingsAndConnectionStrings"]: x })} label="Replace entries in .config files" note={<span>
                            Tentacle will look inside your <em>.config</em> files and attempt to replace any `appSettings`, `applicationSettings` or `connectionStrings` entries that have a `key` or `name` that matches the name of a variable defined
                            in Octopus. For more information, please <ExternalLink href="ConfigurationVariables">see the documentation</ExternalLink>.
                        </span>}/>
            </ProducerSuppliedFormSection>);
    }
    static displayName = "ConfigurationVariablesReadOnly";
}
